import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { fetcher } from '../../client'
import { grabPublicTemplate, bookmarkPublicTemplate, unbookmarkPublicTemplate, updatePublicTemplate, removePublicTemplate, viewPublicTemplate } from '../../actions/templates'

export function useGrabPublicTemplate(options = {}) {
  const { t } = useTranslation(['common']);
  const queryClient = useQueryClient();
  return useMutation((payload) => fetcher(grabPublicTemplate(payload)), {
    ...options,
    onSuccess: (payload, variables) => {
      if (options.onSuccess) options.onSuccess(payload, variables)
      queryClient.invalidateQueries('public-templates');
      toast.success(t('successMessages.addItem', {context: 'female', name: t('template')}))
    }
  });
}

export function useViewPublicTemplate(options = {}) {
  const { t } = useTranslation(['common']);
  return useMutation((payload) => fetcher(viewPublicTemplate(payload)), options);
}

export function useUpdatePublicTemplate(options = {}) {
  const { t } = useTranslation(['common']);
  const queryClient = useQueryClient();
  return useMutation((payload) => fetcher(updatePublicTemplate(payload)), {
    ...options,
    onSuccess: (payload, variables) => {
      if (options.onSuccess) options.onSuccess(payload, variables)
      queryClient.invalidateQueries('public-template');
      toast.success('Los cambios se guardaron con éxito')
    },
    onError: (err) => {
      if (options.onError) options.onError(err)
      toast.error(t(`errorMessages.${err.message}`))
    }
  });
}
export function useRemovePublicTemplate(options = {}) {
  const { t } = useTranslation(['common']);
  const queryClient = useQueryClient();
  return useMutation((payload) => fetcher(removePublicTemplate(payload)), {
    ...options,
    onSuccess: (payload, variables) => {
      if (options.onSuccess) options.onSuccess(payload, variables)
      queryClient.invalidateQueries('public-templates');
      toast.success('La plantilla se borró con éxito')
    },
    onError: (err) => {
      if (options.onError) options.onError(err)
      toast.error(t(`errorMessages.${err.message}`))
    }
  });
}

export function useBookmarkPublicTemplate(options = {}) {
  const { t } = useTranslation(['common']);
  const queryClient = useQueryClient();
  return useMutation((payload) => fetcher(bookmarkPublicTemplate(payload)), {
    ...options,
    onSuccess: (payload, variables) => {
      if (options.onSuccess) options.onSuccess(payload, variables)
      queryClient.invalidateQueries('public-templates');
      queryClient.invalidateQueries('profile');
    }
  });
}

export function useUnbookmarkPublicTemplate(options = {}) {
  const { t } = useTranslation(['common']);
  const queryClient = useQueryClient();
  return useMutation((payload) => fetcher(unbookmarkPublicTemplate(payload)), {
    ...options,
    onSuccess: (payload, variables) => {
      if (options.onSuccess) options.onSuccess(payload, variables)
      queryClient.invalidateQueries('public-templates');
      queryClient.invalidateQueries('profile');
    }
  });
}